import { render, staticRenderFns } from "./genericModal.vue?vue&type=template&id=21ae2cfb&"
import script from "./genericModal.vue?vue&type=script&lang=js&"
export * from "./genericModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\kaharmanny\\source\\repos\\rentmagic.frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ae2cfb')) {
      api.createRecord('21ae2cfb', component.options)
    } else {
      api.reload('21ae2cfb', component.options)
    }
    module.hot.accept("./genericModal.vue?vue&type=template&id=21ae2cfb&", function () {
      api.rerender('21ae2cfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/interface/genericModal.vue"
export default component.exports